<template>
  <div>
    <Navbar />
    <b-overlay v-if="!Loading">
      <div class="container" style="min-height: calc(100vh - 335px); margin-top: 100px">
        <b-row>
          <b-col class="text-left">
            <h2 @click="$router.push({ name: 'Cabinet' })" style="cursor: pointer">
              <b-icon-chevron-left></b-icon-chevron-left>
              {{ $t("CoachAssignment") }}
            </h2>
          </b-col>
          <b-col sm="12" lg="7" class="text-right">
            <div class="d-flex justify-content-end">
              <div class="mr-2">
                <b-button-group
                  @click="TableRefresh"
                  size="sm"
                  class="sport-group-btn"
                >
                  <b-button
                    @click="filterList.seasonid = 1"
                    :variant="
                      filterList.seasonid == 1 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("firstseason") }}
                  </b-button>
                  <b-button
                    @click="filterList.seasonid = 2"
                    :variant="
                      filterList.seasonid == 2 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("secondseason") }}
                  </b-button>
                </b-button-group>
              </div>
              <div class="mr-2">
                <b-button-group
                  @click="TableRefresh"
                  size="sm"
                  class="sport-group-btn"
                >
                  <b-button
                    @click="filterList.docyear = 2022"
                    :variant="
                      filterList.docyear == 2022 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("2022") }}
                  </b-button>
                  <b-button
                    @click="filterList.docyear = 2023"
                    :variant="
                      filterList.docyear == 2023 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("2023") }}
                  </b-button>
                  <b-button
                    @click="filterList.docyear = 2024"
                    :variant="
                      filterList.docyear == 2024 ? 'primary' : 'outline-primary'
                    "
                  >
                    {{ $t("2024") }}
                  </b-button>
                </b-button-group>
              </div>
              <!-- <div class="mr-2">
                <a
                  href="javascript: void(0);"
                  @click="
                    $router.push({ name: 'EditApplication', params: { id: 0 } })
                  "
                  class="btn btn-sm anim-opacity btn-primary"
                >
                  <b-icon-plus></b-icon-plus> {{ $t("Add") }}
                </a>
              </div> -->
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="12">
            <div class="pricing-box1 rounded px-4 pb-2 pt-2 mb-2">
              <b-row>
                <b-col sm="12" md="3" class="text-center">
                  <custom-select
                    :label="$t('')"
                    style="height: 56px"
                    v-model="filterList.genderId"
                    :placeholder="$t('gender')"
                    @input="changeSportGender"
                    :options="GenderList"
                  ></custom-select>
                </b-col>
                <b-col sm="12" md="3" class="text-center">
                  <custom-select
                    :label="$t('')"
                    style="height: 56px"
                    v-model="filterList.ageCategoryId"
                    :placeholder="$t('agecategory')"
                    :options="agecategoryList"
                    @input="changeAgeCategory"
                  ></custom-select>
                </b-col>
                <b-col sm="12" md="3" class="text-center">
                  <custom-select
                    :label="$t('')"
                    style="height: 56px"
                    v-model="filterList.sportTypecCtegoryId"
                    :placeholder="$t('sporttypecategory')"
                    @input="changeSportCategory"
                    :options="sporttypecategorylist"
                  ></custom-select>
                </b-col>
                <b-col sm="12" md="3" class="text-center">
                  <custom-select
                    :label="$t('')"
                    style="height: 56px"
                    v-model="filterList.sportTypeId"
                    :placeholder="$t('sporttype1')"
                    @input="changeSport"
                    :options="SportList"
                  ></custom-select>
                </b-col>
              </b-row>
              <b-row sm="12" md="12" class="mt-2">
                <b-col sm="12" md="4" class="text-center mt-2">
                  <custom-input
                    style="height: 30px"
                    v-model="filterList.Search"
                    :placeholder="$t('search')"
                    :label="$t('')"
                  ></custom-input>
                </b-col>
                <b-col sm="12" md="2" class="mt-2">
                  <b-button
                    block
                    variant="outline-primary"
                    size="sm"
                    style="height: 54px"
                    @click="TableRefresh"
                  >
                    <p class="m-0 p-0 p-1">
                      <b-spinner v-if="Loading" small></b-spinner>
                      {{ $t("search") }}
                    </p>
                  </b-button>
                </b-col>
                <b-col sm="12" md="1" class="mt-2">
                  <b-button
                    block
                    variant="outline-danger"
                    size="sm"
                    style="height: 54px"
                    @click="Clear"
                  >
                    <b-icon-x-circle></b-icon-x-circle>
                  </b-button>
                </b-col>
                <b-col md="3" sm="12" class="mt-1" style="margin-left:180px">
                  <b-button block @click="OpenPersonModal" variant="primary" size="lg">
                    <p class="m-0 p-0 p-1">{{ $t("addacoachassignment") }}</p>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col sm="12" md="12">
            <b-table
              ref="refInvoiceListTable"
              :items="CoachAssignment.Tables"
              responsive
              :fields="fields"
              primary-key="id"
              sticky-header="65vh"
              no-border-collapse
              :busy="isBusy"
              show-empty
              :empty-text="$t('NotFound')"
              class="position-relative"
            >
              <template v-slot:cell(actions)="{ item }">
                <div class="text-center">
                  <!-- <b-link>
                      <feather-icon
                        style="margin-right: 5px"
                        @click="EditTable(item)"
                        icon="EditIcon"
                      ></feather-icon>
                  </b-link>-->
                  <b-link>
                    <b-icon-pencil
                      scale="1"
                      v-if="item.statusid != 2"
                      style="margin-right: 10px"
                      @click="EditRow(item)"
                    ></b-icon-pencil>
                  </b-link>
                  <b-link>
                    <b-icon-trash
                      scale="1"
                      v-if="item.statusid != 2"
                      style="color: red; margin-right: 10px"
                      @click="$bvModal.show('DeleteModal' + item.id)"
                    ></b-icon-trash>
                  </b-link>
                  <b-link>
                    <b-icon-check2-circle
                      scale="1"
                      v-if="item.statusid != 2"
                      style="color: green; margin-right: 10px"
                      @click="$bvModal.show('AcceptModal' + item.id)"
                    ></b-icon-check2-circle>
                  </b-link>
                  <b-link v-if="item.statusid == 2">
                    <b-icon-x-circle
                      scale="1"
                      v-if="item.statusname != 'Удален' && item.statusname != 'Создан'"
                      style="color: red; margin-right: 10px"
                      @click="$bvModal.show('CancelModal' + item.id)"
                    ></b-icon-x-circle>
                  </b-link>
                  <b-modal
                    :id="'DeleteModal' + item.id"
                    :title="$t('delete')"
                    no-close-on-backdrop
                    hide-footer
                  >
                    <p>{{ $t("WantDeleteAdm") }}</p>
                    <b-row>
                      <b-col class="text-right">
                        <a
                          @click="$bvModal.hide('DeleteModal' + item.id)"
                          class="btn btn-sm btn-soft-danger mr-2 pr-btn"
                        >{{ $t("no") }}</a>
                        <a @click="DeleteRow(item)" class="btn btn-sm btn-success pr-btn">
                          <b-spinner v-if="DeleteLoading" small></b-spinner>
                          {{ $t("yes") }}
                        </a>
                      </b-col>
                    </b-row>
                  </b-modal>
                  <b-modal
                    :id="'AcceptModal' + item.id"
                    :title="$t('Approve')"
                    no-close-on-backdrop
                    hide-footer
                  >
                    <b-row class="mt-3">
                      <b-col>
                        <h5>ID : {{ item.id }}</h5>
                      </b-col>
                      <b-col class="text-right">
                        <a
                          @click="$bvModal.hide('AcceptModal' + item.id)"
                          class="btn btn-sm btn-soft-danger mr-2 pr-btn"
                        >{{ $t("no") }}</a>
                        <a @click="Accept(item)" class="btn btn-sm btn-success pr-btn">
                          <b-spinner v-if="SendLoading" small></b-spinner>
                          {{ $t("yes") }}
                        </a>
                      </b-col>
                    </b-row>
                  </b-modal>
                  <b-modal
                    :id="'CancelModal' + item.id"
                    :title="$t('cancel')"
                    no-close-on-backdrop
                    hide-footer
                  >
                    <b-row class="mt-3">
                      <b-col>
                        <h5>ID : {{ item.id }}</h5>
                      </b-col>
                      <b-col class="text-right">
                        <a
                          @click="$bvModal.hide('CancelModal' + item.id)"
                          class="btn btn-sm btn-soft-danger mr-2 pr-btn"
                        >{{ $t("no") }}</a>
                        <a @click="Cancel(item)" class="btn btn-sm btn-success pr-btn">
                          <b-spinner v-if="CancelLoading" small></b-spinner>
                          {{ $t("yes") }}
                        </a>
                      </b-col>
                    </b-row>
                  </b-modal>
                </div>
              </template>
              <template v-slot:cell(index)="{ index }">
                <span class="text-center">{{ index + 1 }}</span>
              </template>
              <template v-slot:cell(statusname)="{ item }">
                <b-badge
                  style="cursor: pointer"
                  :variant="getColor(item.statusid)"
                  class="btn-soft-primary pr-btn"
                  size="sm"
                >{{ item.statusname }}</b-badge>
              </template>
            </b-table>
          </b-col>
          <!-- <b-col sm="12" md="12">
            <b-row class="mt-3" v-if="CoachAssignment.Tables.length > 0">
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted"
                  >{{ $t("Showing") }} {{ firstNumber }} {{ $t("to") }}
                  {{ lastNumber }} {{ $t("of") }} {{ totalRows }}
                  {{ $t("entries") }}</span
                >
              </b-col>
              <b-col
                sm="12"
                md="6"
                class="d-flex align-items-end justify-content-end justify-content-sm-end"
              >
                <b-pagination
                  @input="TableRefresh"
                  v-model="filter.PageNumber"
                  :total-rows="filter.totalRows"
                  :per-page="filter.PageLimit"
                  aria-controls="my-table"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>-->
        </b-row>
        <!-- <b-row class="mt-3 mb-3">
          <b-col class="text-right">
            <b-button variant="success" @click="SaveData">
              <b-spinner v-if="SaveLoading" small></b-spinner> {{ $t("save") }}
            </b-button>
          </b-col>
        </b-row>-->
      </div>
      <b-modal
        v-model="PersonModal"
        :cancel-title="$t('Cancel')"
        :ok-title="$t('add')"
        cancel-variant="danger"
        size="lg"
        ok-variant="success"
        @ok="AddPerson()"
      >
        <template #modal-title>
          {{ $t("CoachAssignment") }}
          <b-spinner v-if="PersonLoading" small></b-spinner>
        </template>
        <b-card-text>
          <b-row class="mb-3">
            <b-col sm="12" md="12" class="d-flex" style="gap:0%">
               <b-form-checkbox
                  size="lg"
                  class="mt-1"
                  @change="changeRequiredGender"
                  v-model="tabrow.isnotrequiredgender"
                  name="checkbox-1"
                >
                </b-form-checkbox>
              <label class="col-form-label" for>{{ $t("Jins talab etilmaydi") }}</label>
            </b-col>
            <b-col sm="12" md="12" class="mt-2" v-if="!tabrow.isnotrequiredgender">
              <custom-select
                :label="$t('gender')"
                :placeholder="$t('choose')"
                v-model="tabrow.genderid"
                @input="changeGender"
                :disabled="!canchange"
                :options="GenderList"
              ></custom-select>
            </b-col>
            <b-col sm="12" md="12" class="mt-3">
              <custom-select
                :label="$t('agecategory')"
                v-model="tabrow.agecategoryid"
                @input="changeCategory"
                :placeholder="$t('choose')"
                :options="AgeCategoryList"
              ></custom-select>
            </b-col>
            <b-col sm="12" md="12" class="mt-3">
              <custom-select            
                :label="$t('sporttypecategory')"
                :placeholder="$t('choose')"
                v-model="tabrow.sporttypecategoryid"
                :options="SportTypeCategoryList"
                @input="changeSportTypeCategory"
              ></custom-select>
            </b-col>
            <b-col sm="12" md="12" class="mt-3">
              <custom-select
                :disabled="!canchange"
                :label="$t('sporttype1')"
                :placeholder="$t('choose')"
                v-model="tabrow.sporttypeid"
                @input="changeSportType"
                :options="SportTypeList"
              ></custom-select>
            </b-col>
          </b-row>
        </b-card-text>
      </b-modal>
    </b-overlay>
    <div
      v-if="Loading"
      style="width: 100%; height: calc(100vh - 335px)"
      class="d-flex align-items-center justify-content-center"
    >
      <b-spinner></b-spinner>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";
import {
  BIconPlus,
  BIconPaperclip,
  BIconTrash,
  BIconCheck2Circle,
  BIconXCircle,
  BIconChevronLeft,
  BIconX,
  BIconExclamationTriangleFill,
  BIconCheckCircleFill,
  BIconSearch,
  BListGroup,
  BOverlay,
  BIconPencil,
  BFormCheckbox
} from "bootstrap-vue";
import CustomSelect from "./components/CustomSelect.vue";
import CustomInput from "./components/CustomInput.vue";
import CustomDatePicker from "./components/CustomDatepicker.vue";
import CustomLabel from "./components/CustomLabel.vue";
import RegistrationOfAthleteService from "../services/registrationofathlete.service";
import HelperService from "../services/helper.service";
import OblastService from "../services/oblast.service";
import RegionService from "../services/region.service";
import MfyService from "../services/mfy.service";
import SportTypeService from "../services/sporttype.service";
import SportTypeCategoryService from "../services/sporttypecategory.service";
import RegionSectorService from "../services/regionsector.service";
import CoachAssignmentService from "../services/coachassignment.service";
import AgeCategoryService from "../services/agecategory.service";
import PersonService from "../services/person.service";
export default {
  components: {
    Navbar,
    BIconPlus,
    BIconSearch,
    BOverlay,
    CustomSelect,
    CustomInput,
    CustomDatePicker,
    BIconPencil,
    CustomLabel,
    BIconCheck2Circle,
    BIconXCircle,
    BIconPaperclip,
    BIconTrash,
    Footer,
    BIconChevronLeft,
    BListGroup,
    BIconX,
    BIconExclamationTriangleFill,
    BIconCheckCircleFill,
    BFormCheckbox
  },
  data() {
    return {
      CoachAssignment: {},
      OblastList: [],
      lang : localStorage.getItem('locale'),
      RegionList: [],
      coachassignmentid:0,
      PersonModal: false,
      isBusy: false,
      MfyList: [],
      items: [],
      RegionSectorList: [],
      GenderList: [],
      canchange: false,
      totalRows: "",
      DeleteLoading: false,
      SendLoading: false,
      AgeCategoryList: [],
      agecategoryList: [],
      selectMode: "multi",
      selected: [],
      GroupNameData: {
        SportTypeName: "",
        AgeCategoryName: "",
        GenderName: "",
        athletecount: 0,
        translatecount: 0
      },
      YouthLeaderAssignmentByPerson:{},
      tabrow: {
        id: 0,
        ownerid: 0,
        sporttypeid: 0,
        sporttypename: "",
        agecategoryid: 0,
        agecategoryname: "",
        sporttypecategoryid: 0,
        sporttypecategoryname: "",
        groupname: "",
        genderid: 0,
        gendername: "",
        Status: 1,
        isnotrequiredgender: false,
      },
      IdentityDocumentList: [],
      List:[],
      filter: {
        oblastid: 0,
        regionid: 0,
        regionsectorid: 0,
        mfyid: 0,
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 400,
        pageOptions: [5, 10, 15, 20, 25, 50, 100],
        SortIcon: "arrow-up"
      },
      filterList: {
        genderId: 0,
        genderName: "",
        ageCategoryId: 0,
        ageCategoryName: "",
        sportTypecCtegoryId: 0,
        sportTypecCtegoryName: "",
        sportTypeId: 0,
        sportTypeName: "",
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 400,
        docyear:2024,
        seasonid:2
      },
      editedIndex1: -1,
      lang: localStorage.getItem("locale") || "uz_latn",
      DocumentSeriesList: [],
      SearchLoading: false,
      AcceptLoading: false,
      CancelLoading: false,
      PersonLoading: false,
      SaveLoading: false,
      Loading: false,
      SportTypeList: [],
      SportList: [],
      SportTypeCategoryList: [],
      sporttypecategorylist: [],
      fields1: [
        {
          key: "selected",
          label: this.$t(""),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "fullname",
          label: this.$t("FIO"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "documentseries",
          label: this.$t("documentseries"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false
        },
        {
          key: "documentnumber",
          label: this.$t("documentnumber"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false
        },
        {
          key: "dateofbirth",
          label: this.$t("dateofbirth"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false
        },
        // {
        //   key: "dateofissue",
        //   label: this.$t("dateofissue"),
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: false,
        // },
        {
          key: "gendername",
          label: this.$t("gender"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        }
        // {
        //   key: "pinfl",
        //   label: this.$t("pinfl"),
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: true,
        // },
      ],
      fields: [
        {
          key: "index",
          label: this.$t("index"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "gendername",
          label: this.$t("gender"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "agecategoryname",
          label: this.$t("agecategory"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "sporttypecategoryname",
          label: this.$t("sporttypecategory"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "sporttypename",
          label: this.$t("sporttype1"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "groupname",
          label: this.$t("group"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false
        },
        {
          key: "statusname",
          label: this.$t("status"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false
        },
        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false
        }
      ]
    };
  },
  computed: {
    firstNumber() {
      return this.totalRows > 0
        ? (this.filter.PageNumber - 1) * this.filter.PageLimit + 1
        : 0;
    },
    lastNumber() {
      if (this.totalRows < this.filter.PageLimit) {
        return this.totalRows;
      } else {
        if (this.filter.PageNumber * this.filter.PageLimit > this.totalRows) {
          return this.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    }
  },
  created() {
    this.Loading = true;
    OblastService.GetAll(this.lang).then(res => {
      this.OblastList = res.data;
    });
    HelperService.GetGenderList(this.lang).then(res => {
      this.GenderList = res.data;
    });
    CoachAssignmentService.Get(
      0,
      JSON.parse(localStorage.getItem("user_info")).MobileNumber,
      this.lang
    ).then(res => {
      this.CoachAssignment = res.data;
      this.coachassignmentid = res.data.id;
      this.tabrow.ownerid = res.data.id;
      this.CoachAssignment.docnumber = 1;
        this.CoachAssignment.detail = "string";
      this.GetYouthLeaderAssignmentByPerson();
        this.CoachAssignment.docnumber = 1;
        this.CoachAssignment.detail = "string";
       if(this.coachassignmentid == 0 || this.coachassignmentid == null || this.coachassignmentid == undefined){
        CoachAssignmentService.Update(this.CoachAssignment)
          .then(res => {
            this.coachassignmentid = res.data.result.id;
            this.tabrow.ownerid = res.data.result.id;
          })
          .catch(error => {
            this.makeToast(error.response.data.error, "error");
            this.$router.push({
            name: "Cabinet",
          });
          });
       }
          this.TableRefresh();
      this.calculate();
      this.Loading = false;
    })
    .catch(error => {
      this.makeToast(error.response.data.error, "error");
    });
  },
  methods: {
    calculate() {
      var self = this;
      var index = 0;
      self.CoachAssignment.Tables.forEach(function(item) {
        if (item.Status !== 3) {
          index++;
        }
      });
      if (index > 0) self.canchange = false;
      else self.canchange = true;
    },
    rowClass(item, type) {
      if (item.Status === 3 && !!item.Status) {
        return "d-none";
      }
    },

    EditRow(item) {
      CoachAssignmentService.GetCoachAssignmentTable(item.id)
        .then(res1 => {
          this.tabrow = res1.data;
          if (!!this.tabrow.genderid) {
            this.GetYouthLeaderAssignmentByPerson();
          this.getAgecategory();
            if (!!this.tabrow.genderid && !!this.tabrow.agecategoryid) {
              SportTypeService.GetAll(
                this.lang,
                "",
                this.tabrow.genderid,
                this.tabrow.agecategoryid,
                this.tabrow.sporttypecategoryid
              ).then(res => {
                this.SportTypeList = res.data;
              });
            }
          }
          this.PersonModal = true;
        })
        .catch(error => {
          this.makeToast(error.response.data.error, "error");
        });
    },
    DeleteRow(item) {
      CoachAssignmentService.DeleteCoachAssignmentTable(item.id)
        .then(res2 => {
          this.makeToast(this.$t("DeleteSuccess"), "success");
          this.TableRefresh();
          this.calculate();
        })
        .catch(error => {
          this.makeToast(error.response.data.error, "error");
        });
    },
    Clear() {
      this.filterList = {
        genderId: 0,
        genderName: "",
        ageCategoryId: 0,
        ageCategoryName: "",
        sportTypecCtegoryId: 0,
        sportTypecCtegoryName: "",
        sportTypeId: 0,
        sportTypeName: "",
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 400,
        docyear:2024,
        seasonid:2
      };
      this.TableRefresh();
    },
    changeGender() {
      if (!!this.tabrow.genderid) {
        this.tabrow.gendername = this.GenderList.filter(
          item => this.tabrow.genderid === item.id
        )[0].name;
       this.getAgecategory();
        if(this.tabrow.genderid == null){
          this.tabrow.genderid = 0
        }
      }
      this.tabrow.agecategoryid = 0;
      this.tabrow.sporttypecategoryid = 0;
      (this.tabrow.sporttypeid = 0), (this.tabrow.detail = "");
    },
    getAgecategory(){   
      AgeCategoryService.GetAll(this.lang, this.tabrow.genderid, '', true, this.YouthLeaderAssignmentByPerson.initiativtypeid)
          .then(res1 => {
            this.AgeCategoryList = res1.data;
          })
          .catch(error => {
            this.makeToast(error.response.data.error, "error");
          });
    },
    changeRequiredGender(){
      if(this.tabrow.isnotrequiredgender == true){
        this.tabrow.genderid = 0;
        this.tabrow.sporttypeid= 0;
        this.tabrow.sporttypecategoryid= 0;
        this.tabrow.agecategoryid= 0;
        this.getAgecategory();
      }
    },
    changeSportType() {
      this.tabrow.sporttypename = this.SportTypeList.filter(
        item => this.tabrow.sporttypeid === item.id
      )[0].name;
    },
      changeSportGender() {
      if (!!this.filterList.genderId) {
        this.filterList.genderName = this.GenderList.filter(
          item => this.filterList.genderId === item.id
        )[0].name;
        AgeCategoryService.GetAll(this.lang, this.filterList.genderId)
          .then(res1 => {
            this.agecategoryList = res1.data;
          })
          .catch(error => {
            this.makeToast(error.response.data.error, "error");
          });
      }
      this.filterList.ageCategoryId = 0;
      this.filterList.sportTypecCtegoryId = 0;
      (this.filterList.sportTypeId = 0), (this.filterList.detail = "");
    },
      changeAgeCategory() {
      if (!!this.filterList.ageCategoryId) {
        this.filterList.ageCategoryName = this.agecategoryList.filter(
          item => this.filterList.ageCategoryId === item.id
        )[0].name;
        SportTypeCategoryService.GetAll(this.lang, this.filterList.ageCategoryId, false, )
          .then(res1 => {
            this.sporttypecategorylist = res1.data;
            // this.Sport()
          })
          .catch(error => {
            this.makeToast(error.response.data.error, "error");
          });
      }
      // this.filterList.ageCategoryId = 0;
      this.filterList.sportTypecCtegoryId = 0;
      (this.filterList.sportTypeId = 0), (this.filterList.detail = "");
    },
    changeSport() {
      this.filterList.sportTypeName = this.SportList.filter(
        item => this.filterList.sportTypeId === item.id
      )[0].name;
    },
    OpenPersonModal() {
      if (!this.check()) {
        return false;
      }
      this.tabrow = {
        id: 0,
        ownerid: this.tabrow.ownerid,
        sporttypeid: 0,
        sporttypename: "",
        agecategoryid: 0,
        agecategoryname: "",
        groupname: "",
        genderid: 0,
        gendername: "",
        Status: 1
      };
      this.PersonModal = true;
    },
    SortChange(data) {
      this.filter.Sort = data.sortBy;
      this.filter.Order = data.sortDesc ? "desc" : "asc";
    },
    changeCategory() {
      this.tabrow.sporttypeid = 0;
      this.tabrow.sporttypecategoryid = 0;
      this.tabrow.detail = "";
      if (!!this.tabrow.agecategoryid) {
        this.tabrow.agecategoryname = this.AgeCategoryList.filter(
          item => this.tabrow.agecategoryid === item.id
        )[0].name;
        SportTypeCategoryService.GetAll(this.lang, this.tabrow.agecategoryid, true, null, this.YouthLeaderAssignmentByPerson.initiativtypeid, this.tabrow.genderid)
          .then(res1 => {
            this.SportTypeCategoryList = res1.data;
            // this.Sport()
          })
          .catch(error => {
            this.makeToast(error.response.data.error, "error");
          });
      }
    },
    changeSportTypeCategory() {
      if(!!this.tabrow.sporttypecategoryid){
        this.tabrow.sporttypecategoryname = this.SportTypeCategoryList.filter(
          item => this.tabrow.sporttypecategoryid === item.id
        )[0].name;
      }
      this.tabrow.sporttypeid = 0;
      this.tabrow.detail = "";
      this.SportType();
    },
    SportType() {
      SportTypeService.GetAll(
        this.lang,
        "",
        this.tabrow.genderid,
        this.tabrow.agecategoryid,
        this.tabrow.sporttypecategoryid,
        true,
        this.YouthLeaderAssignmentByPerson.initiativtypeid
      ).then(res => {
        this.SportTypeList = res.data;
      });
    },
    changeSportCategory() {
      if(!!this.filterList.sportTypecCtegoryId){
        this.filterList.sportTypecCtegoryName = this.sporttypecategorylist.filter(
          item => this.filterList.sportTypecCtegoryId === item.id
        )[0].name;
      }
      this.filterList.sportTypeId = 0;
      this.filterList.detail = "";
      this.Sport();
    },
    Sport() {
      SportTypeService.GetAll(
        this.lang,
        "",
        this.filterList.genderId,
        this.filterList.ageCategoryId,
        this.filterList.sportTypecCtegoryId
      ).then(res => {
        this.SportList = res.data;
      });
    },
    getRegionSector() {
      if (!!this.CoachAssignment.mfyid) {
        RegionSectorService.GetAll(this.lang)
          .then(res => {
            this.RegionSectorList = res.data;
          })
          .catch(error => {
            this.makeToast(error.response.data.error, "error");
          });
      }
    },
    GetYouthLeaderAssignmentByPerson() {
      PersonService.GetYouthLeaderAssignmentByPerson(this.lang).then((res) => {
        this.YouthLeaderAssignmentByPerson = res.data.result;
       if (this.YouthLeaderAssignmentByPerson.initiativtypeid == 3) {
          this.CoachAssignment.oblastid = this.YouthLeaderAssignmentByPerson.orgProfEduInfo.oblastid;
          this.CoachAssignment.oblastname = this.YouthLeaderAssignmentByPerson.orgProfEduInfo.oblastname;
          this.CoachAssignment.regionid = this.YouthLeaderAssignmentByPerson.orgProfEduInfo.regionid;
          this.CoachAssignment.regionname = this.YouthLeaderAssignmentByPerson.orgProfEduInfo.regionname;
          this.CoachAssignment.organizationid = this.YouthLeaderAssignmentByPerson.orgProfEduInfo.organizationid;
          this.CoachAssignment.organizationname = this.YouthLeaderAssignmentByPerson.orgProfEduInfo.organizationname;
        }
        else if(this.YouthLeaderAssignmentByPerson.initiativtypeid == 2){
          this.CoachAssignment.oblastid = this.YouthLeaderAssignmentByPerson.schoolInfo.oblastid;
          this.CoachAssignment.oblastname = this.YouthLeaderAssignmentByPerson.schoolInfo.oblastname;
          this.CoachAssignment.regionid = this.YouthLeaderAssignmentByPerson.schoolInfo.regionid;
          this.CoachAssignment.regionname = this.YouthLeaderAssignmentByPerson.schoolInfo.regionname;
          this.CoachAssignment.organizationid = this.YouthLeaderAssignmentByPerson.schoolInfo.organizationid;
          this.CoachAssignment.organizationname = this.YouthLeaderAssignmentByPerson.schoolInfo.organizationname;
        }
        else if(this.YouthLeaderAssignmentByPerson.initiativtypeid == 1){
          this.CoachAssignment.oblastid = this.YouthLeaderAssignmentByPerson.oblastid;
          this.CoachAssignment.oblastname = this.YouthLeaderAssignmentByPerson.oblastname;
          this.CoachAssignment.regionid = this.YouthLeaderAssignmentByPerson.regionid;
          this.CoachAssignment.regionname = this.YouthLeaderAssignmentByPerson.regionname;
          this.CoachAssignment.regionsectorid = this.YouthLeaderAssignmentByPerson.regionsectorid;
          this.CoachAssignment.regionsectorname = this.YouthLeaderAssignmentByPerson.regionsectorname;
          this.CoachAssignment.mfyid = this.YouthLeaderAssignmentByPerson.mfyid;
          this.CoachAssignment.mfyname = this.YouthLeaderAssignmentByPerson.mfyname;
        }
        else {
          this.CoachAssignment.oblastid = this.YouthLeaderAssignmentByPerson.orgHighEduInfo.oblastid;
          this.CoachAssignment.oblastname = this.YouthLeaderAssignmentByPerson.orgHighEduInfo.oblastname;
          this.CoachAssignment.regionid = this.YouthLeaderAssignmentByPerson.orgHighEduInfo.regionid;
          this.CoachAssignment.regionname = this.YouthLeaderAssignmentByPerson.orgHighEduInfo.regionname;
          this.CoachAssignment.organizationid = this.YouthLeaderAssignmentByPerson.orgHighEduInfo.organizationid;
          this.CoachAssignment.organizationname = this.YouthLeaderAssignmentByPerson.orgHighEduInfo.organizationname;
        }
        // console.log(res.data.result)
      });
    },
    AddPerson() {
      if (!this.check1()) {
        return false;
      }
      //   this.SaveLoading = true;
      this.tabrow.groupname =
        this.CoachAssignment.mfyname +
        " " +
        this.tabrow.agecategoryname +
        " " +
        this.tabrow.gendername +
        " " +
        this.tabrow.sporttypecategoryname +
        " " +
        this.tabrow.sporttypename;
      CoachAssignmentService.UpdateCoachAssignmentTable(this.tabrow)
        .then(res => {
          //   this.SaveLoading = false;
          this.makeToast(this.$t("SaveSuccess"), "success");
          this.TableRefresh();
        })
        .catch(error => {
          //   this.SaveLoading = false;
          this.makeToast(error.response.data.error, "error");
        });
    },
    TableRefresh() {
      //   this.Loading = true;
      CoachAssignmentService.GetCoachAssignmentTableList(
        this.coachassignmentid,
        this.filterList.genderId,
        this.filterList.ageCategoryId,
        this.filterList.sportTypecCtegoryId,
        this.filterList.sportTypeId,
        this.filterList.Search,
        this.filterList.SortColumn,
        this.filterList.OrderType,
        this.filterList.PageNumber,
        this.filterList.PageLimit,
        this.filterList.docyear,
        this.filterList.seasonid
      )
        .then(res => {
          this.CoachAssignment.Tables = res.data.rows;
          //   this.Loading = false;
        })
        .catch(error => {
          this.makeToast(error.response.data.error, "error");
          this.Loading = false;
        });
    },
    getColor(id) {
      return id === 1
        ? "primary"
        : id === 2
        ? "success"
        : id === 3
        ? "danger"
        : id === 4
        ? "primary"
        : "primary";
    },
    makeToast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 5000,
        dismissible: true
      });
    },
    Accept(item) {
      this.SendLoading = true;
      CoachAssignmentService.Approve(item.id)
        .then(res => {
          this.SendLoading = false;
          this.$bvModal.hide("AcceptModal" + item.id);
          this.TableRefresh();
        })
        .catch(error => {
          this.makeToast(error.response.data.error, "error");
          this.SendLoading = false;
        });
    },
    Cancel(item) {
      this.CancelLoading = true;
      CoachAssignmentService.CancelApproval(item.id)
        .then(res => {
          this.CancelLoading = false;
          this.$bvModal.hide("CancelModal" + item.id);
          this.TableRefresh();
        })
        .catch(error => {
          this.makeToast(error.response.data.error, "error");
          this.CancelLoading = false;
        });
    },
    check() {
      if (
        this.CoachAssignment.docnumber === 0 ||
        this.CoachAssignment.docnumber === null ||
        this.CoachAssignment.docnumber === undefined ||
        this.CoachAssignment.docnumber === ""
      ) {
        this.makeToast(this.$t("docnumberNotSelected"), "error");
        return false;
      }
      if (
        this.CoachAssignment.docdate === 0 ||
        this.CoachAssignment.docdate === null ||
        this.CoachAssignment.docdate === undefined ||
        this.CoachAssignment.docdate === ""
      ) {
        this.makeToast(this.$t("docdateNotCorrect"), "error");
        return false;
      }
      if (
        this.CoachAssignment.oblastid === 0 ||
        this.CoachAssignment.oblastid === null ||
        this.CoachAssignment.oblastid === undefined ||
        this.CoachAssignment.oblastid === ""
      ) {
        this.makeToast(this.$t("NotSelectoblastid"), "error");
        return false;
      }
      if (
        this.CoachAssignment.regionid === 0 ||
        this.CoachAssignment.regionid === null ||
        this.CoachAssignment.regionid === undefined ||
        this.CoachAssignment.regionid === ""
      ) {
        this.makeToast(this.$t("NotSelectregionid"), "error");
        return false;
      }
      if(this.YouthLeaderAssignmentByPerson.initiativtypeid == 1){
        if (
        this.CoachAssignment.mfyid === 0 ||
        this.CoachAssignment.mfyid === null ||
        this.CoachAssignment.mfyid === undefined ||
        this.CoachAssignment.mfyid === ""
      ) {
        this.makeToast(this.$t("mfyNotSelected"), "error");
        return false;
      }
      if (
        this.CoachAssignment.regionsectorid === 0 ||
        this.CoachAssignment.regionsectorid === null ||
        this.CoachAssignment.regionsectorid === undefined ||
        this.CoachAssignment.regionsectorid === ""
      ) {
        this.makeToast(this.$t("regionsectorNotSelected"), "error");
        return false;
      }
      }
      //   if (
      //     this.tabrow.genderid === 0 ||
      //     this.tabrow.genderid === null ||
      //     this.tabrow.genderid === undefined ||
      //     this.tabrow.genderid === ""
      //   ) {
      //     this.makeToast(this.$t("genderNotSelected"), "error");
      //     return false;
      //   }
      //   if (
      //     this.tabrow.agecategoryid === 0 ||
      //     this.tabrow.agecategoryid === null ||
      //     this.tabrow.agecategoryid === undefined ||
      //     this.tabrow.agecategoryid === ""
      //   ) {
      //     this.makeToast(this.$t("agecategoryNotSelected"), "error");
      //     return false;
      //   }
      //   if (
      //     this.tabrow.sporttypeid === 0 ||
      //     this.tabrow.sporttypeid === null ||
      //     this.tabrow.sporttypeid === undefined ||
      //     this.tabrow.sporttypeid === ""
      //   ) {
      //     this.makeToast(this.$t("sporttypeNotSelected"), "error");
      //     return false;
      //   }
      //   if (
      //     this.tabrow.detail === 0 ||
      //     this.tabrow.detail === null ||
      //     this.tabrow.detail === undefined ||
      //     this.tabrow.detail === ""
      //   ) {
      //     this.makeToast(this.$t("detailNotCorrect"), "error");
      //     return false;
      //   }
      // if (this.CoachAssignment.Tables.length === 0) {
      //   this.makeToast(this.$t("TablesNotFilled"), "danger");
      //   return false;
      // }
      return true;
    },
    check1() {
      if (
        this.CoachAssignment.docnumber === 0 ||
        this.CoachAssignment.docnumber === null ||
        this.CoachAssignment.docnumber === undefined ||
        this.CoachAssignment.docnumber === ""
      ) {
        this.makeToast(this.$t("docnumberNotSelected"), "error");
        return false;
      }
      if (
        this.CoachAssignment.docdate === 0 ||
        this.CoachAssignment.docdate === null ||
        this.CoachAssignment.docdate === undefined ||
        this.CoachAssignment.docdate === ""
      ) {
        this.makeToast(this.$t("docdateNotCorrect"), "error");
        return false;
      }
      if (
        this.CoachAssignment.oblastid === 0 ||
        this.CoachAssignment.oblastid === null ||
        this.CoachAssignment.oblastid === undefined ||
        this.CoachAssignment.oblastid === ""
      ) {
        this.makeToast(this.$t("oblastNotSelected"), "error");
        return false;
      }
      if (
        this.CoachAssignment.regionid === 0 ||
        this.CoachAssignment.regionid === null ||
        this.CoachAssignment.regionid === undefined ||
        this.CoachAssignment.regionid === ""
      ) {
        this.makeToast(this.$t("regionNotSelected"), "error");
        return false;
      }
      if(this.YouthLeaderAssignmentByPerson.initiativtypeid == 1){
        if (
        this.CoachAssignment.mfyid === 0 ||
        this.CoachAssignment.mfyid === null ||
        this.CoachAssignment.mfyid === undefined ||
        this.CoachAssignment.mfyid === ""
      ) {
        this.makeToast(this.$t("mfyNotSelected"), "error");
        return false;
      }
      if (
        this.CoachAssignment.regionsectorid === 0 ||
        this.CoachAssignment.regionsectorid === null ||
        this.CoachAssignment.regionsectorid === undefined ||
        this.CoachAssignment.regionsectorid === ""
      ) {
        this.makeToast(this.$t("regionsectorNotSelected"), "error");
        return false;
      }
      }
      //   if (
      //     this.tabrow.genderid === 0 ||
      //     this.tabrow.genderid === null ||
      //     this.tabrow.genderid === undefined ||
      //     this.tabrow.genderid === ""
      //   ) {
      //     this.makeToast(this.$t("genderNotSelected"), "error");
      //     return false;
      //   }
      //   if (
      //     this.tabrow.agecategoryid === 0 ||
      //     this.tabrow.agecategoryid === null ||
      //     this.tabrow.agecategoryid === undefined ||
      //     this.tabrow.agecategoryid === ""
      //   ) {
      //     this.makeToast(this.$t("agecategoryNotSelected"), "error");
      //     return false;
      //   }
      //   if (
      //     this.tabrow.sporttypeid === 0 ||
      //     this.tabrow.sporttypeid === null ||
      //     this.tabrow.sporttypeid === undefined ||
      //     this.tabrow.sporttypeid === ""
      //   ) {
      //     this.makeToast(this.$t("sporttypeNotSelected"), "error");
      //     return false;
      //   }
      return true;
    },
    BindValue(data) {
      this.filter.dateofbirth = data;
    },
    SaveData() {
      //   if (this.AdoptionPermission.KadastrData === null) {
      //     this.makeToast(this.$t("NotKadastrInfo"), "error");
      //     return false;
      if (!this.check1()) {
        return false;
      }
      this.SaveLoading = true;
      CoachAssignmentService.Update(this.CoachAssignment)
        .then(res => {
          this.SaveLoading = false;
          this.$router.push({ name: "CoachAssignment" });
        })
        .catch(error => {
          this.SaveLoading = false;
          this.makeToast(error.response.data.error, "error");
        });
    }
  }
};
</script>

<style lang="scss">
.application-modal {
  .modal-xl {
    min-width: 1300px !important;
  }
}
</style>
